import { render, staticRenderFns } from "./ForcaDeVendaFormulario.vue?vue&type=template&id=249bb48e"
import script from "./ForcaDeVendaFormulario.vue?vue&type=script&lang=js"
export * from "./ForcaDeVendaFormulario.vue?vue&type=script&lang=js"
import style0 from "./ForcaDeVendaFormulario.vue?vue&type=style&index=0&id=249bb48e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports